import { makeApiRequest } from 'actions/api';
import { GET_USER_BEHAVIORAL_DISCOUNTS } from 'lib/constants/v3Actions';
import * as fromDashboard from 'reducers/dashboard';
import RequestService from 'services/RequestService';

export const getUserBehavioralDiscounts = menuSlug =>
  makeApiRequest({
    requestType: GET_USER_BEHAVIORAL_DISCOUNTS,
    method: RequestService.v3.getUserBehavioralDiscounts,
    params: { menuSlug },
  });

export const refreshUserBehavioralDiscounts = menuSlug => async (dispatch, getState) => {
  const state = getState();
  const menuSlugs = fromDashboard.selectMenuSlugs(state);
  const menusToFetch = menuSlugs.slice(menuSlugs.indexOf(menuSlug));

  return await fetchUserBehavioralDiscountsForMenus(menusToFetch, dispatch);
};

export const fetchUserBehavioralDiscountsForMenus = (menuSlugs, dispatch) => {
  return Promise.all(menuSlugs.map(menuSlug => dispatch(getUserBehavioralDiscounts(menuSlug))));
};
